import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import React from 'react';

import {
  CriteriaTextWrapper,
  MatchStyledText,
} from '../../SmartChoiceBreakDown.styles';

interface NotAMatchPremiumCarePhysicianTextProps {
  text: string;
  StartIcon?: React.ReactNode;
  EndIcon?: React.ReactNode;
}
export const NotAMatchPremiumCarePhysicianText = ({
  text,
  StartIcon,
  EndIcon,
}: NotAMatchPremiumCarePhysicianTextProps) => (
  <CriteriaTextWrapper data-testid={`not-a-match-text-${text}`}>
    <IconSymbol color="#C24E14" icon="search_off" />
    {StartIcon && <React.Fragment>{StartIcon}</React.Fragment>}
    {text && (
      <CriteriaTextWrapper>
        <MatchStyledText>{text}</MatchStyledText>
        {EndIcon && <React.Fragment>{EndIcon}</React.Fragment>}
      </CriteriaTextWrapper>
    )}
  </CriteriaTextWrapper>
);
